module.exports = __webpack_public_path__ + "static/img/bg.9cbc524a.png";